export default {
  index: {
    title: 'アカウント管理',
    tab: {
      baseTitle: 'アカウント情報',
      resetTitle: 'パスワードの変更',
      profileTitle: '基本情報',
    },
  },
  base: {
    submitText: '保存',
    successText: '保存成功',
  },
  reset: {
    submitText: '確認の提出',
    successText: '変更が成功しました',
    verifycode: 'キーの検証に失敗しました、もう一度試してください',
    describe:
      'このパスワードは、MobvistaテクノロジーのMobvista配下のすべての製品に適用されます。',
  },
  form: {
    name: {
      label: 'ユーザー名：',
      title: 'ユーザー名',
    },
    contact: {
      title: '連絡先名',
    },
    cell: {
      title: '連絡先電話',
      placeholder: '電話番号を入力してください',
    },
    organization: {
      title: '会社',
      placeholder: '会社名を入力してください',
    },
    country: {
      title: '国または地域',
      placeholder: '国または地域を選択してください',
    },
    mail: {
      label: 'メール：',
      placeHolder: 'メールアドレスを入力してください',
      required: 'メールアドレスは空白にできません',
      formatVeryfy:
        'メールの形式が正しくありません、修正して再試行してください',
      title: '連絡先メールアドレス',
    },
    password: {
      label: '現在のパスワード',
      placeHolder: '現在のパスワードを入力してください',
      required: '現在のパスワードは空白にできません',
      validatePassNewOld: '新旧のパスワードは同じであってはいけません',
      validatePassSame:
        '入力されたパスワードが一致しません、もう一度入力してください',
      validatePass:
        '8〜20文字の長さ、数字と大文字小文字の両方の組み合わせ（例：Psw1234567）',
      validatePassEmpty: 'パスワードは空白にできません',
    },
    newPassword: {
      label: '新しいパスワード',
      placeHolder: '新しいパスワードを入力してください',
      required: '新しいパスワードは空白にできません',
    },
    confirmPassword: {
      label: 'パスワードの確認',
      placeHolder: '確認用のパスワードを入力してください',
      required: '確認用のパスワードは空白にできません',
    },
    ccEmail: {
      title: 'CCメールアドレス',
      tip: 'Playturboからのメッセージ通知を受信するために複数のメールを追加することを許可',
      validate: 'メールアドレスが正しくありません',
      placeholder: 'CCメールアドレスを入力してください',
    },
    currency: {
      title: '決済通貨',
    },
  },
  plan: {
    expirationReminder: '期限切れのリマインダー',
    expirationReminderTips: 'ご契約がまもなく終了します。更新してください。',
    insufficientQuota: '残高不足',
    insufficientQuotaTips:
      'パッケージのクォータが尽きると、30日以内に自動的に権限がキャンセルされます。引き続きサービスを利用するために、すぐに更新してください。',
    message: {
      confirm: '了解しました',
    },
  },
}
